import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebNewsPaperIndex({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const hotspots = questionData?.display?.elements[0]?.hotspots || [];

    const [activeHotspot, setActiveHotspot] = useState(null);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setActiveHotspot(null);
    }, [question]);

    const handleClick = (hotspot) => {
        setActiveHotspot(hotspot.id);

        const canProceed = true;
        onAnswer({
            canProceed,
            answer: hotspot.id,
        });
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    display: "inline-block",
                    padding: "20px",
                    backgroundColor: "white",
                }}
            >
                <Box sx={{ position: "relative", width: "100%" }}>
                    <Box component="img"
                        src={`${imagesResources}${data.image}`}
                        alt="Question"
                        sx={{ width: "100%", height: "auto" }}
                    />
                    {hotspots.map((hotspot, index) => (
                        <Button
                            key={index}
                            onClick={() => handleClick(hotspot)}
                            sx={{
                                position: "absolute",
                                top: hotspot.top,
                                left: hotspot.left,
                                width: hotspot.width,
                                height: hotspot.height,
                                backgroundColor:
                                    activeHotspot === hotspot.id
                                        ? "rgba(255, 217, 102, 0.75)"
                                        : "transparent",
                                border:
                                    activeHotspot === hotspot.id
                                        ? "2px solid rgb(255, 192, 0)"
                                        : "none",
                                "&:hover": {
                                    backgroundColor:
                                        activeHotspot === hotspot.id
                                            ? "rgba(255, 217, 102, 0.25)"
                                            : "rgba(0, 0, 255, 0.1)",
                                },
                            }}
                        ></Button>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};